import { render, staticRenderFns } from "./AddGuidanceCategoryPage.vue?vue&type=template&id=d070c9b8&"
import script from "./AddGuidanceCategoryPage.vue?vue&type=script&lang=js&"
export * from "./AddGuidanceCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports